import React from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import ExpandMenu, { ExpandMenuItem } from "shared/ExpandMenu"
import { store } from "store"
import * as API from "services/api"
import { formSubmissionSlug as getFormSubmissionSlug, setAttachments, submissionPermissions as getSubmissionPermissions } from "reduxSlices/formSubmissionSlice"
import ExpandMenuEllipsisButton from "shared/buttons/ExpandMenuEllipsisButton"

const AttachmentMenu = ({ attachment, isDownloadable = true }) => {
  const { isDeletable } = attachment
  const formSubmissionSlug = useSelector(getFormSubmissionSlug)
  const { canDeleteAttachments } = useSelector(getSubmissionPermissions)
  const renderDeleteButton = canDeleteAttachments && isDeletable

  const deleteAttachment = async () => {
    if (window.confirm("Are you sure you want to delete this attachment?")) {
      const attachmentId = attachment.id
      const apiFunction = attachment.type === "attachments" ? API.deleteAttachment : API.deleteSubmittedFile

      const response = await apiFunction({ formSubmissionSlug, attachmentId })

      if (response.ok) {
        store.dispatch(setAttachments(response.data))
      } else {
        console.error("Error deleting attachment: ", response)
      }
    }
  }

  if (!renderDeleteButton && !isDownloadable) return null

  return (
    <ExpandMenu
      expandMenuComponent={(<ExpandMenuEllipsisButton className="absolute top-2 right-2 bg-white rounded p-1.5" />)}
    >
      {
        isDownloadable
        && (
          <ExpandMenuItem>
            <a
              href={attachment.downloadPath}
              target="_blank"
              rel="noopener noreferrer"
            >
              Download
            </a>
          </ExpandMenuItem>
        )
      }
      {
        renderDeleteButton
        && (
          <ExpandMenuItem onClick={deleteAttachment}>
            <span>Delete</span>
          </ExpandMenuItem>
        )
      }
    </ExpandMenu>
  )
}

AttachmentMenu.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  attachment: types.object.isRequired,
  isDownloadable: types.bool,
}

export default AttachmentMenu
